export enum CertType {
    Kakao = 'kakao',
    Naver = 'naver',
    Pass = 'pass',
  }
  
  export const CertTitleMap: Record<CertType, string> = {
    [CertType.Kakao]: '카카오톡',
    [CertType.Naver]: '네이버',
    [CertType.Pass]: '패스앱',
  };

  export const Cert = Object.values(CertType); // ← 배열로 뽑아주기